import React from "react";
import "./index.less";
import LogoImg from "imgs/logo.svg";

export default function App({  }) {
    return (
        <div className="header-wrap">
            <img className="header-logo" src={LogoImg} />
            <div className="header-menu">
                <a className="header-menu-item" href="https://dfmc.hotjob.cn/wt/DFMC/web/index">首页</a>
                <a className="header-menu-item" href="https://dfmc.hotjob.cn/wt/DFMC/web/index/social">社会招聘</a>
                <a className="header-menu-item" href="https://sp.wintalent.cn/dfmc/recurit/index.html">校园招聘</a>
                <a className="header-menu-item" href="https://dfmc.hotjob.cn/wt/DFMC/web/index/interns">实习生招聘</a>
                <a className="header-menu-item" href="https://dfmc.hotjob.cn/wt/DFMC/web/index/overseas">海外招聘</a>
                <a className="header-menu-item" href="https://www.dfmc.com.cn/zoujindf/qiyegaikuang/qiyejieshao.html" target="_blank">公司介绍</a>
            </div>
        </div>
    )
}